import { FormHelperText } from '@mui/material';
import styled from 'styled-components';

export const FormRow = styled.div`
  width: 500px;
`;

export const StyledFormHelperText = styled(FormHelperText)`
  margin-left: 0px;
  margin-top: 0px;
`;
